module.exports = __webpack_public_path__ + "static/media/32-12.3206febd.mp3";